module.exports = __webpack_public_path__ + "img/arrow-next.3700aa90.svg";